import { CustomerContact } from "@core/models/customer-contact.model";

export class CustomerContactViewModel {
	id: string;
	firstName: string;
	lastName: string;
	displayName: string;

	constructor (customerContact: CustomerContact) {
		this.id = customerContact.id || "";
		this.firstName = customerContact.firstName || "";
		this.lastName = customerContact.lastName || "";

		this.displayName = (this.firstName + " " + this.lastName).trim(); // removes spaces in case first or last name is empty
	}
}
